import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomStockProtectionOverviewList, SerialNoStatusResponseList } from '../custom-stock-potection.models';
import { CustomStockProtectionAdapter } from '../custom-stock-protection.adapter';
import * as CustomStockProtectionActions from './custom-stock-protection.actions';

@Injectable()
export class CustomStockProtectionEffects {

    constructor(
        private actions$: Actions,
        private customStockProtectionAdapter: CustomStockProtectionAdapter
    ) {}

    getStockProtection$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(CustomStockProtectionActions.getStockProtectionOverview),
          switchMap(() =>
            this.customStockProtectionAdapter
              .getStockProtection(
              )
              .pipe(
                map((stockProtectionOverview: CustomStockProtectionOverviewList) =>
                  CustomStockProtectionActions.getStockProtectionOverviewSuccess
                  ({
                    stockProtectionOverview,
                  })
                ),
                catchError((error) =>
                  of(
                    CustomStockProtectionActions.getStockProtectionOverviewFailure({
                      error,
                    })
                  )
                )
              )
          )
        );
    });

    searchStockProtection$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(CustomStockProtectionActions.searchStockProtection),
        switchMap((action) =>
          this.customStockProtectionAdapter
            .searchStockProtection(
              action.productCode,
              action.processNumber,
              action.scenarioCode
            )
            .pipe(
              map((stockProtectionOverview: CustomStockProtectionOverviewList) =>
              CustomStockProtectionActions.searchStockProtectionSuccess
              ({
                stockProtectionOverview,
              })
            ),
            catchError((error) =>
              of(
                CustomStockProtectionActions.searchStockProtectionFailure({
                  error,
                })
              )
            )
            )
        )
      );
    });

    getStockProtectionDetails$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(CustomStockProtectionActions.getStockProtectionDetails),
        switchMap((action) =>
          this.customStockProtectionAdapter
            .getStockProtectionDetails(
              action.processNumber
            )
            .pipe(
              map((stockProtectionDetails: SerialNoStatusResponseList) =>
                CustomStockProtectionActions.getStockProtectionDetailsSuccess
                ({
                  stockProtectionDetails,
                })
              ),
              catchError((error) =>
                of(
                  CustomStockProtectionActions.getStockProtectionDetailsFailure({
                    error,
                  })
                )
              )
            )
        )
      );
  });

  updateSerialNumbers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomStockProtectionActions.updateSerialNumbers),
      switchMap((action) =>
        this.customStockProtectionAdapter
          .updateSerialNumbers(
            action.processNumber,
            action.serialNumbers
          )
          .pipe(
            map((stockProtectionDetails: SerialNoStatusResponseList) =>
              CustomStockProtectionActions.updateSerialNumbersSuccess
              ({
                stockProtectionDetails,
              })
            ),
            catchError((error) =>
              of(
                CustomStockProtectionActions.updateSerialNumbersFailure({
                  error,
                })
              )
            )
          )
      )
    );
});
}